<ng-container *ngIf="planningItem" [formGroup]="planningItemForm">
  <app-disabled-form-input [label]="'GENERAL.DATETIME.START_DATE' | bmsTranslate" [value]="startDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY'"></app-disabled-form-input>
  <app-disabled-form-input [label]="'GENERAL.DATETIME.END_DATE' | bmsTranslate" [value]="endDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY'"></app-disabled-form-input>

  <vdw-datepicker-form-input
    class="date"
    [inputLabel]="'PLANNING.PLANNING_ITEM_FIELDS.EARLIEST_START_DATE' | bmsTranslate"
    [optional]="true"
    [form]="planningItemForm"
    formControlNameValue="earliestStartDate"
  ></vdw-datepicker-form-input>
  <mat-form-field class="time">
    <mat-label>
      {{ 'PLANNING.PLANNING_ITEM_FIELDS.EARLIEST_START_TIME' | bmsTranslate }}
      <span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
    </mat-label>
    <input matInput appTime formControlName="earliestStartTime" />
  </mat-form-field>
  <mat-form-field class="time" *ngIf="minimumDurationControl">
    <mat-label>
      {{ 'PLANNING.PLANNING_ITEM_FIELDS.MINIMUM_DURATION' | bmsTranslate }}
      <span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
    </mat-label>
    <input matInput type="number" min="0" vdwL10nDecimal [decimals]="true" [maximumFractionDigits]="2" [formControl]="minimumDurationControl" />
    <span matSuffix>{{ 'GENERAL.UNIT.HOURS' | bmsTranslate }}</span>
    <mat-error *ngIf="minimumDurationControl.hasError('badInput')">
      {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
    </mat-error>
  </mat-form-field>
</ng-container>
